// import React, { useState, useRef } from "react";
// import { message, Spin } from "antd";
// import Button from "../components/Button";
// import Bridge from "../constants/Bridge";
// import Recaptcha from 'react-google-invisible-recaptcha';

// const GOOGLE_RECAPTCHA_SITE_KEY = "6LdSRKwqAAAAAJKXC7DOnge0_kpIqjxz885Sjstp"; // Replace with your site key

// const Login = () => {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [type1, setType1] = useState("password");
//   const [captchaToken, setCaptchaToken] = useState("");
//   const recaptchaRef = useRef(null);

//   const loginPlease = () => {
//     console.log("email", email, "password", password, "captchaToken", captchaToken);
//     if (!email) {
//       message.warning("Please enter email address first.");
//       return;
//     }
//     if (!password) {
//       message.warning("Please enter password.");
//       return;
//     }
//     if (!captchaToken) {
//       message.warning("Please complete the reCAPTCHA verification.");
//       return;
//     }

//     setLoading(true);

//     const params = {
//       email,
//       password,
//       recaptchaToken: captchaToken,
//     };

//     Bridge.login(params)
//       .then((response) => {
//         setLoading(false);
//         if (response.data.status === 1) {
//           console.log("response------>", response);
//           message.success(response.data.message);
//           localStorage.setItem("token", response.data.token);
//           // Additional storage logic...
//           window.location.assign(
//             response.data.is_site_manager === "yes"
//               ? "/mystudies/dashboard"
//               : "/dashboard"
//           );
//         } else {
//           message.error(response.data.message);
//         }
//       })
//       .catch((error) => {
//         message.warning("Please try again!", error);
//         setLoading(false);
//       });
//   };

//   const handleRecaptchaVerify = (token) => {
//     console.log(token);

//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     recaptchaRef.current.execute();
//   };
//   const onResolved = (token) => {
//     if (token) {
//       setCaptchaToken(token);
//       loginPlease();
//     } else {
//       setCaptchaToken('');
//       loginPlease();
//     }
//   }
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     if (name == "email") {
//       setEmail(value);
//     } else if (name == "password") {
//       setPassword(value);
//     }
//   };

//   const togglePassword = () => {
//     setType1((prev) => (prev === "password" ? "text" : "password"));
//   };

//   return (
//     <div className="multisteps-form__panel js-active login-page" data-animation="slideVert">
//       <div className="inner pb-50">
//         <div className="wizard-content-item text-center" style={{ paddingTop: 0 }}>
//           <img
//             src="/assets/img/ecas-logo-white.png"
//             className="logo-img"
//             style={{ margin: "0 auto", marginBottom: 0, maxWidth: 220, width: 240 }}
//           />
//           <h2>EALS Consortia Portal Log-In</h2>
//         </div>
//         <div className="row">
//           <div className="col-lg-4 m-auto">
//             <div className="wizard-content-form">
//               <Spin spinning={loading}>
//                 <div className="wizard-form-field">
//                   <div className="wizard-form-input position-relative form-group has-float-label">
//                     <input
//                       type="text"
//                       className="form-control"
//                       name="email"
//                       placeholder="Email Address"
//                       value={email}
//                       onChange={(e)=>{setEmail(e.target.value);
//                       }}
//                     />
//                     <label>Email Address</label>
//                   </div>
//                   <div className="wizard-form-input position-relative form-group has-float-label">
//                     <input
//                       type={type1}
//                       className="form-control"
//                       name="password"
//                       placeholder="Password"
//                       value={password}
//                       onChange={(e)=>{setPassword(e.target.value);
//                       }}
//                     />
//                     <label>Password</label>
//                     <div className="togglePassword" onClick={togglePassword}>
//                       {type1 === "password" ? (
//                         <i className="fas fa-eye-slash"></i>
//                       ) : (
//                         <i className="fas fa-eye"></i>
//                       )}
//                     </div>
//                   </div>
//                   <Recaptcha
//                     ref={recaptchaRef}
//                     sitekey={GOOGLE_RECAPTCHA_SITE_KEY}
//                     badge="inline"
//                     size="normal"
//                     onResolved={onResolved} />
//                   <div className="mt-3">
//                     <a href="/forgot-password" style={{ textDecoration: "none", color: "#546adf", position: "relative", top: -10, fontWeight: "600", fontSize: 15 }}>
//                       Forgot Password?
//                     </a>
//                   </div>
//                   <center>
//                     <Button to="#" isClickable={true} click={handleSubmit} style={{ width: "100%" }}>
//                       <i className="fa fa-arrow-right" aria-hidden="true"></i>
//                       &nbsp;&nbsp; Login
//                     </Button>
//                   </center>
//                 </div>
//               </Spin>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Login;


import React, { Component, createRef } from "react";
import { message, Spin } from "antd";
import Button from "../components/Button";
import Bridge from "../constants/Bridge";
import Recaptcha from "react-google-invisible-recaptcha";
import {GOOGLE_RECAPTCHA_SITE_KEY} from "../constants/consts";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      loading: false,
      type1: "password",
      captchaToken: "",
    };
    this.recaptchaRef = createRef();
  }

  loginPlease = async () => {
    const { email, password, captchaToken } = this.state;
    if (!email.trim()) {
      message.warning("Please enter your email address.");
      this.setState({ loading: false });
      return;
    }
    if (!password.trim()) {
      message.warning("Please enter your password.");
      this.setState({ loading: false });
      return;
    }
    if (!captchaToken) {
      message.warning("Please complete the reCAPTCHA verification.");
      this.setState({ loading: false });
      return;
    }

    this.setState({ loading: true });

    const params = { email, password, recaptchaToken: captchaToken };

    try {
      console.log("Calling Bridge.login with params:", params);

      const response = await Bridge.login(params);
      console.log("Response received:", response);

      if (response.data.status === 1) {
        message.success(response.data.message);
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("is_site_manager", response.data.is_site_manager);
        localStorage.setItem("provide_study_dashboard_access", response.data.provide_study_dashboard_access);
        localStorage.setItem("sites", response.data.sites);
        localStorage.setItem("consortia_company_member_name", response.data.company_member_name);
        localStorage.setItem("consortia_name", response.data.name);
        localStorage.setItem("consortia_company_level", response.data.level_name);
        localStorage.setItem("consortia_company_id", response.data.company_id);
        localStorage.setItem("consortia_user_id", response.data.consortia_user_id);
        
        window.location.assign(
          response.data.is_site_manager === "yes"
            ? "/mystudies/dashboard"
            : "/dashboard"
        );
      } else {
        message.error(response.data.message);
      }
    } catch (error) {
      console.error("Error during login:", error);
      if (error.message.includes("Timeout")) {
        message.error("Login request timed out. Please try again.");
      } else {
        message.error("An error occurred. Please try again.");
      }
    } finally {
      this.setState({ loading: false });
    }
  };

  handleRecaptchaVerify = (token) => {
    console.log("reCAPTCHA resolved with token:", token);
    if (token) {
      this.setState({ captchaToken: token }, this.loginPlease);
    } else {
      message.error("Failed to complete reCAPTCHA. Please try again.");
      this.setState({ loading: false }); // Stop loading if reCAPTCHA fails
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { email, password } = this.state;

    console.log("Submit clicked with email:", email, "password:", password);
    if (!email.trim() || !password.trim()) {
      message.warning("Please fill in all required fields.");
      return;
    }

    this.setState({ loading: true }, () => {
      console.log("Executing reCAPTCHA...");
      this.recaptchaRef.current.execute();
    });
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  togglePassword = () => {
    this.setState((prevState) => ({
      type1: prevState.type1 === "password" ? "text" : "password",
    }));
  };

  render() {
    const { email, password, loading, type1 } = this.state;

    return (
      <div
        className="multisteps-form__panel js-active login-page"
        data-animation="slideVert"
      >
        <div className="inner pb-50">
          <div
            className="wizard-content-item text-center"
            style={{ paddingTop: 0 }}
          >
            <img
              src="/assets/img/ecas-logo-white.png"
              className="logo-img"
              style={{
                margin: "0 auto",
                marginBottom: 0,
                maxWidth: 220,
                width: 240,
              }}
            />
            <h2>EALS Consortia Portal Log-In</h2>
          </div>
          <div className="row">
            <div className="col-lg-4 m-auto">
              <div className="wizard-content-form">
                <Spin spinning={loading}>
                  <div className="wizard-form-field">
                    <div className="wizard-form-input position-relative form-group has-float-label">
                      <input
                        type="text"
                        className="form-control"
                        name="email"
                        placeholder="Email Address"
                        value={email}
                        onChange={this.handleChange}
                      />
                      <label>Email Address</label>
                    </div>
                    <div className="wizard-form-input position-relative form-group has-float-label">
                      <input
                        type={type1}
                        className="form-control"
                        name="password"
                        placeholder="Password"
                        value={password}
                        onChange={this.handleChange}
                      />
                      <label>Password</label>
                      <div
                        className="togglePassword"
                        onClick={this.togglePassword}
                      >
                        {type1 === "password" ? (
                          <i className="fas fa-eye-slash"></i>
                        ) : (
                          <i className="fas fa-eye"></i>
                        )}
                      </div>
                    </div>
                    <Recaptcha
                      ref={this.recaptchaRef}
                      sitekey={GOOGLE_RECAPTCHA_SITE_KEY}
                      onResolved={this.handleRecaptchaVerify}
                    />
                    <div className="mt-3">
                      <a
                        href="/forgot-password"
                        style={{
                          textDecoration: "none",
                          color: "#546adf",
                          position: "relative",
                          top: -10,
                          fontWeight: "600",
                          fontSize: 15,
                        }}
                      >
                        Forgot Password?
                      </a>
                    </div>
                    <center>
                      <Button
                        to="#"
                        isClickable={true}
                        click={this.handleSubmit}
                        style={{ width: "100%" }}
                      >
                        <i className="fa fa-arrow-right" aria-hidden="true"></i>
                        &nbsp;&nbsp; Login
                      </Button>
                    </center>
                  </div>
                </Spin>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Login;
